import { useEffect, useState } from "react";
import React from 'react';
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Select from "react-select";
import SuiInput from "components/SuiInput";
import MovementReasonsSelect from "../components/MovementReasonsSelect";
import CampaignProvider from "../../../providers/CampaignProvider";
import UsersProvider from "../../../providers/UsersProvider";
import { useForm } from 'react-hook-form';
import ActionRequestButtons from "../components/ActionRequestButtons";
import requesterErrorMessages from '../../../static/messages/errorMessages.json';
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";
import useAlert from "../../../common/useAlert";

export const ActivityStatusEscalation = React.memo(({ preloadData, setApiRequestObj }) => {
  const { register, handleSubmit, formState: { errors }, getValues, setValue  } = useForm();
  const { alert } = useAlert();

  const [errorMessages, setErrorMessages] = useState(null);
  const [movementReasonId, setMovementReasonId] = useState(null);
  // const [activityStatusId, setActivityStatusId] = useState(null);
  const requestor = preloadData?.Requestor || null;
  const actionedForManager = preloadData?.RequestData?.ManagerUserEmployeeNumber || null;
  const activityStatusId = preloadData?.RequestData?.ActivityStatusId || null;
   const activityStatusOptions = [
    {
      id: 1,
      name:"Training",
      movementReasonId: 14
    },
    {
      id: 2,
      name:"Feeder",
      movementReasonId: 16
    },
    {
      id: 3,
      name:"Floor Training",
      movementReasonId: 17
    },
    {
      id: 4,
      name:"Actively Dialling",
      movementReasonId: 18
    },
  ];
  
  if(preloadData && preloadData.RequestStatus !== "NEW"){
    alert({
      icon:'error',
      title: 'This request has already been actioned',
    });
   
    setTimeout(() =>  window.location.reload(), 2000);

    return;
  }

  const onSubmit = () => {   
    if(activityStatusId && preloadData?.RequestId && localStorage.getItem("EmployeeNumber")){
      setApiRequestObj({
        RequestType: 'APPROVE ESCALATION',
        RequestDescription: "portal-request",
        CreatedBy: localStorage.getItem("UserName") || null,
        RequesterUserEmployeeNumber: actionedForManager,
        ApproverUserEmployeeNumber: localStorage.getItem("EmployeeNumber"),
        UserHierarchyMovementReasonId: activityStatusOptions.find((item) => item.id === activityStatusId)?.movementReasonId || "",
        ActivityStatusId: activityStatusId || null,
        EscalationRequestId: preloadData.RequestId
      })
    }
    
  };
  const handleFormSubmit = handleSubmit(onSubmit);

  useEffect(async() => {
    setErrorMessages(requesterErrorMessages['teamManagement'].requests['campaignEscalation']);
  }, [])

  if(!preloadData){
    return (
      <>
      <SuiBox display={'flex'} gap={2} alignItems='center' >
        <SuiTypography
            component="span"
            variant="body2"
            color={"error"}
          >
            Escalations must be actioned from the Approvals tab:
          </SuiTypography>
        <a href="/approvals">
          <SuiTypography
            component="span"
            variant="body2"
            color={"dark"}
            mb
          >
            Approvals Page
            &nbsp;
            <Icon>link</Icon>
          </SuiTypography>
        </a>
        </SuiBox>
      </>
    )
  }
  
  return (
    <>
    {errorMessages && <>
      <SuiBox mt={4} mb={2} lineHeight={1}>
        <SuiTypography sx={{paddingBottom: '0.5rem'}} variant="h6">Request being actioned for</SuiTypography>
        <SuiInput
          label={`User`}
          id={`userEscalationRef`}
          name={`userEscalationRef`}
          disabled={true}
          value={`${requestor?.FullName} ( ${requestor?.EmployeeNumber} )`}
        />
      </SuiBox>
      <SuiBox mt={4} mb={2} lineHeight={1}>
        <SuiTypography sx={{paddingBottom: '0.5rem'}} variant="h6">Activity Status Selected By Agent:</SuiTypography>
        <SuiInput
          label={`User`}
          id={`userEscalationRef`}
          name={`userEscalationRef`}
          disabled={true}
          value={`${activityStatusOptions.find((item) => item.id === activityStatusId)?.name || ""}`}
        />
      </SuiBox>
      <ActionRequestButtons onSubmit={handleFormSubmit}/>
    </>}
    </>
  )
});
